import React from "react";

import * as utils from "./misc/utils";

export const PoiCategory = ({ category, lang, linkBaseUrl, noSelTC }) => {
  const categoryName = lang === "de" ? category.name_de : category.name_en;
  return (
    <span className="text-primary">
      {noSelTC ? (
        categoryName
      ) : (
        <a href={linkBaseUrl + "category=" + category._id}>{categoryName}</a>
      )}
    </span>
  );
};

export const TagsList = ({ tags, lang, linkBaseUrl, noSelTC }) => {
  const tagOutput = noSelTC
    ? (tag) => (
        <span key={tag._id} className="text-primary">
          {lang === "de" ? tag.title_de : tag.title_en}
        </span>
      )
    : (tag) => (
        <span key={tag._id} className="text-primary">
          <a href={linkBaseUrl + `tags=${tag._id}`}>
            {lang === "de" ? tag.title_de : tag.title_en}
          </a>
        </span>
      );
  return tags && tags.length > 0 ? (
    tags.map((tag) => tagOutput(tag)).reduce(utils.joiner(", "), [])
  ) : (
    <></>
  );
};
